import { initStore } from "./store";
import enableDisableActive from "./../services/enableDisableActive";

const configureStore = () => {
  console.log("Configure");
  const actions = {
    CLICKED_TYPE: (curState, typeId) => {
      const typeIndex = curState.types.findIndex((t) => t.id === typeId);
      const tempTypes = [
        ...curState.types,
        {
          sensortype_id: "12",
          sensortype_name: "Κατανάλωση ενέργειας",
          sensortype_color: "#cb6de9",
          sensortype_icon: "im im-icon-On-Off-3",
          tooltip: null,
          description: null,
        },
        {
          id: "8",
          name: "Δρομολόγια Απορριμματοφόρων",
          icon: "im im im im-icon-Truck",
          tooltip: "Δείτε απευθείας τα μετεωρολογικά δεδομένα της περιοχής μας",
          color: "#FF8700",
          url: "",
          isActive: false,
        },
      ];

      const updatedTypes = enableDisableActive(tempTypes, typeIndex);

      return { types: updatedTypes };
    },
    INITIALIZE_TYPES: (state, types) => ({ types: types }),
  };

  initStore(actions, { types: [] });
};
export default configureStore;
